import { render, staticRenderFns } from "./PitchShow.vue?vue&type=template&id=c4801f60"
import script from "./PitchShow.vue?vue&type=script&lang=js"
export * from "./PitchShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports